import { FaceManShimmerOutlineIcon } from './FaceManShimmerOutlineIcon';

/**
 * author: Simran
 * id CC7A66A4-2118-4635-B227-C184D8903867
 * name face-man-shimmer-outline
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/face-man-shimmer-outline.svg
 * tags
 * - People / Family 
 * - Photography 
 * - Health / Beauty 
 * - Account / User 
 */
export const FaceRetouchingNaturalOutlineIcon = FaceManShimmerOutlineIcon;
export default FaceRetouchingNaturalOutlineIcon